<template>
  <v-dialog
    v-model="value"
    width="320"
    fullscreen
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="caps-button-show-preview"
        :loading="processingPreview"
        :disabled="processingPreview"
        v-bind="attrs"
        color="primary"
        @click="$emit('show-preview')"
      >
        Show Preview to Continue
      </v-btn>
    </template>
    <v-card
      data-cy="dialog-card-preview"
      style="overflow:scroll;"
    >
      <v-card-title>
        Preview
      </v-card-title>
      <div
        v-if="pdfSrc"
        data-cy="dialog-card-preview-pdf"
      >
        <pdf
          v-for="i in numPages"
          :key="i"
          ref="pdf"
          :src="pdfSrc"
          :page="i"
        />
      </div>
      <v-card-actions class="bottom-bar">
        <v-row
          wrap
          justify="center"
        >
          <v-col
            cols="auto"
            class="py-2"
          >
            <v-btn
              id="preview-button-back"
              text
              outlined
              @click="$emit('input', false)"
            >
              Back
            </v-btn>
          </v-col>
          <v-col
            cols="auto"
            class="py-3"
          >
            <v-btn
              id="preview-button-send-to-production-manger"
              :loading="loading"
              :disabled="loading"
              color="primary"
              @click="$emit('submit')"
            >
              Send to Production Manager
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pdf from 'vue-pdf';

export default {
  components: {
    pdf,
  },
  props: {
    pdfSrc: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
    },
    value: {
      type: Boolean,
    },
    processingPreview: {
      type: Boolean,
    },
    numPages: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style>
  .bottom-bar{
    position: fixed;
    bottom: 0px;
    width: 100%;
    background-color: white;
    padding: 0 30px;
  }
</style>
